export const orderProduct = {
  'order-product.continue': 'Order now',
  'order-product.not-available': 'That item is no longer available.',
};
